export default `
  query($items: [String]!, $reason: String) {
    validateDuplicateDenounces(items: $items, reason: $reason) {
      item_id
      reason_id
    }
  }
`;
